import PropTypes from 'prop-types';
import React from 'react';

export default function ResultStyles(props) {
  const { settings } = props;
  const {
    darkColor,
    borderColor,
    backgroundColor,
    textColor,
    containerCssSelector = '',
  } = settings;

  const styles = `
    ${containerCssSelector} .snapgadget-result{
      border-left-color: ${darkColor};
      border-left-width: 5px;
      ${borderColor ? `border: solid 1px ${borderColor}` : ''};
      ${backgroundColor ? `background-color:${backgroundColor}` : ''};
    }
    ${containerCssSelector} .snapgadget-result p{
      color: ${textColor};
    }
    ${containerCssSelector} .snapgadget-result h4 a{
      color: ${darkColor};
    }
    ${containerCssSelector} .snapgadget-original-price a{
      color: ${textColor};
    }
  `;
  return (
    <style dangerouslySetInnerHTML={{ __html: styles }} />
  );
}

ResultStyles.propTypes = {
  settings: PropTypes.shape({
    darkColor: PropTypes.string,
    borderColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    textColor: PropTypes.string,
    containerCssSelector: PropTypes.string,
  }).isRequired,
};
